import { Typography } from "@mui/material";

import { SerialsAggregator } from "components/formFields/Serials/SerialsAggregator/SerialsAggregator";
import { subLineWrapperStyle } from "components/formFields/lineItemFieldStyle";

import { i18n } from "services/i18nService";

export function LineSerialsEnter(props) {
  const { value, quantity, onValueChange, error, lineReadOnly } = props;

  return (
    <div style={subLineWrapperStyle}>
      <Typography sx={{ flex: "0 1 auto", fontSize: "0.8125rem" }}>
        {i18n("columns.colon.Serials")}
      </Typography>
      <SerialsAggregator
        value={value}
        quantity={quantity}
        onValueChange={onValueChange}
        error={error}
        lineReadOnly={lineReadOnly}
      />
    </div>
  );
}
